import noop from 'utils/noop';
import { Tooltip } from 'ui/tooltip';
import {
  useBrandAffinityTranslation,
  BRAND_AFFINITY_NAMES_TO_I18N_KEYS,
  BRAND_AFFINITY_TOOLTIP_I18N_KEYS,
} from 'modules/domains/brandAffinity';
import { BrandAffinity } from './BrandAffinity';
import { BrandAffinityXAI } from './BrandAffinityXAI';
import type { BrandAffinityIndicatorProps } from './types';

export const BrandAffinityIndicator = ({
  setXAIStatus = noop,
  withXAI,
  level,
}: BrandAffinityIndicatorProps) => {
  const { t } = useBrandAffinityTranslation();

  if (withXAI) {
    return (
      <BrandAffinityXAI
        affinityText={`${t('product.name')}: ${t(BRAND_AFFINITY_NAMES_TO_I18N_KEYS[level])}`}
        containerLabel="brand-affinity-indicator"
        level={level}
        setXAIStatus={setXAIStatus}
      />
    );
  }

  return (
    <Tooltip
      tooltipContent={t(BRAND_AFFINITY_TOOLTIP_I18N_KEYS[level], {
        productDescription: t('product.description'),
      })}
    >
      <BrandAffinity
        affinityText={`${t('product.name')}: ${t(BRAND_AFFINITY_NAMES_TO_I18N_KEYS[level])}`}
        containerLabel="brand-affinity-indicator"
        level={level}
      />
    </Tooltip>
  );
};
